{
  "empty": {
    "blog": "Nothing published here yet.",
    "search": "No results for “{{q}}”.",
    "generic": "Nothing here yet."
  },
  "error": {
    "404": {
      "title": "This page doesn't exist.",
      "body": "It may have moved, or the link may be wrong."
    },
    "500": {
      "title": "Something broke on my end.",
      "body": "It's logged and I'll see it. Try again in a moment."
    },
    "offline": {
      "title": "You're offline.",
      "body": "Pages you've already visited are still readable.",
      "libraryTitle": "Readable without a connection",
      "libraryBody": "These pages are already stored on this device. Everything else needs the network.",
      "libraryEmpty": "Nothing is stored on this device yet. Pages you open while online become readable here.",
      "retry": "Try again",
      "restored": "You are back online."
    },
    "rateLimit": {
      "title": "Too many requests.",
      "body": "Wait a moment and try again."
    },
    "boundary": {
      "title": "This section failed to load.",
      "body": "The rest of the page still works."
    }
  },
  "pwa": {
    "update": "A new version is available.",
    "updateAction": "Reload",
    "installed": "Installed.",
    "install": "Install this site",
    "offlineReady": "Ready to read offline.",
    "updateBody": "Reload to pick up the latest content and fixes.",
    "updateLater": "Later",
    "updating": "Updating…",
    "updateHeld": "An update is ready. It will apply once your unsaved work is saved.",
    "installTitle": "Install this site",
    "installBody": "Add it to your device to read it offline and open it like an app.",
    "installAction": "Install",
    "installDismiss": "Not now",
    "iosTitle": "Add to Home Screen",
    "iosBody": "Safari installs sites from the Share menu.",
    "iosStep1": "Tap the Share button in Safari.",
    "iosStep2": "Scroll down and choose “Add to Home Screen”.",
    "iosStep3": "Tap “Add”.",
    "online": "Back online.",
    "offline": "Offline",
    "offlineBody": "Pages you have already opened are still readable.",
    "viewOffline": "See what is readable"
  }
}
